import { render } from "./CadastroMensagensPadraoView.vue?vue&type=template&id=c7492c92&scoped=true"
import script from "./CadastroMensagensPadraoView.vue?vue&type=script&lang=js"
export * from "./CadastroMensagensPadraoView.vue?vue&type=script&lang=js"

import "./CadastroMensagensPadraoView.vue?vue&type=style&index=0&id=c7492c92&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7492c92"]])

export default __exports__